module.exports = __webpack_public_path__ + "static/media/ldb-logo-sustainability.338fc817.svg";